import { render, staticRenderFns } from "./CateringDeliveries.vue?vue&type=template&id=3e7f349a&scoped=true"
import script from "./CateringDeliveries.vue?vue&type=script&lang=js"
export * from "./CateringDeliveries.vue?vue&type=script&lang=js"
import style0 from "./CateringDeliveries.vue?vue&type=style&index=0&id=3e7f349a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f349a",
  null
  
)

export default component.exports